import React, { useState, useEffect } from 'react';
import style from './Reporting.module.css';
import { Table, Pagination, Spin, Tag, message, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { FormInput } from '../../components/Basic/FormInput';
import * as XLSX from 'xlsx';
import * as Action from '../../store/slices/reporting'
import { connect } from 'react-redux';
import Header from '../../components/Header/header';
import { hasPermission } from '../../utils/premission';
import { PERMISSIONS } from '../../utils/constant/permissions';


interface GetData {
    SearchFilter: (payload: any) => unknown;
    ExportFile: (payload: any) => unknown;
    Reporting_Red: any;
}

interface DataSource {
    key: string;
    CampaignName: string;
    StartTime: string;
    EndTime: string;
    CampaignType: string;
    Status: string;

}

interface Form {
    StartDate: string;
    EndDate: string;
    CampaignId: String;
}

const validationSchema = yup.object().shape({
    StartDate: yup.string().optional(),
    EndDate: yup.string().optional(),
    CampaignId: yup.string().optional(),
});

const MultiViewTable: React.FC<GetData> = ({ SearchFilter, Reporting_Red ,ExportFile}) => {
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(9);
    const [spinning, setSpinning] = React.useState(false);
    const [totalRecords, setTotalRecords] = useState<number>(0);
    const [searchText, setSearchText] = useState<string>('');   
    const [loadingText, setLoadingText] = useState<boolean>(true)
    const [tableData, setTableData] = useState<DataSource[]>([]);

    useEffect(() => {
        const status = Reporting_Red?.dataSingle?.[0]?.res?.status;
        if (status === '1004') {
            localStorage.clear();
            navigate('/');
        } else if (status === '1005') {
            message.warning('No data available');
            setTableData([]);
        }
    }, [Reporting_Red]);
 

    console.log(Reporting_Red,'asdasd')

    const handleExport = async () => {
        setSpinning(true);
        const values = getValues();
        const campaignIds = (values.CampaignId || '')
            .split(',')
            .map(id => parseInt(id.trim(), 10))
            .filter(id => !isNaN(id));
        const payload = {
            startDate: values.StartDate,
            endDate: values.EndDate,
            campaignIds: campaignIds,
            isExport: true,
            pageIndex: 0,
            pageRecord: 500,
        };

        try {
            const response: any = await ExportFile(payload);
            if (response?.csvData) {
                const blob = new Blob([response?.csvData], { type: "text/csv;charset=utf-8;" });
                const link = document.createElement("a");
                const url = URL.createObjectURL(blob);
                link.href = url;
                link.download = 'Campaign Audit Report.csv';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
                message.success("Report downloaded successfully!");
            } else {
                message.error('No data to export');
            }
        } catch (error) {
            console.error('Error exporting data:', error);
            message.error('Failed to export data');
        } finally {
            setSpinning(false);
        }
    };
   
   
    const allColumns = [
        {
            title: 'Campaign Id',
            dataIndex: 'campaignId',
            key: 'campaignId',
            width: 80,
            sorter: (a: DataSource, b: DataSource) => a.CampaignType.localeCompare(b.CampaignType),
        },
        {
            title: 'Campaign Name',
            dataIndex: 'campaignName',
            key: 'campaignName',
            width: 150,
            sorter: (a: DataSource, b: DataSource) => a.CampaignName.localeCompare(b.CampaignName),

        },
        
        {
            title: 'Start Date',
            dataIndex: 'startDate',
            key: 'startDate',
            width: 120,
            sorter: (a: DataSource, b: DataSource) => a.StartTime.localeCompare(b.StartTime),
        },
        {
            title: 'End Date',
            dataIndex: 'endDate',
            key: 'endDate',
            width: 100,
            sorter: (a: DataSource, b: DataSource) => a.EndTime.localeCompare(b.EndTime),
        },

        {
            title: 'No Of Winners',
            dataIndex: 'noOfWinners',
            key: 'noOfWinners',
            width: 100,
        },
        {
            title: 'Status  ',
            dataIndex: 'campaignStatus',
            key: 'campaignStatus',
            width: 100,
        },
        {
            title: 'Create By',
            dataIndex: 'createdByName',
            key: 'createdByName',
            width: 100,
        },
        {
            title: 'Approved By',
            dataIndex: 'approvedByName',
            key: 'approvedByName',
            width: 100,
        },


    ];

    useEffect(() => {
        setLoadingText(true)
        setTimeout(() => {
            setLoadingText(false)
        }, 2000)
    }, [])
    const {
        control,
        formState: { errors },
        handleSubmit,
        getValues,
        setValue
    } = useForm<Form>({
        defaultValues: {
            StartDate: '',
            EndDate: '',
            CampaignId: '',
        },
        mode: 'onChange',
        resolver: yupResolver(validationSchema) as any,
    });

    const searchFilter = async () => {
        setSpinning(true);
        const values = getValues();
        const campaignIds = (values.CampaignId || '')
            .split(',')
            .map(id => parseInt(id.trim(), 10))
            .filter(id => !isNaN(id));
        const payload = {
            startDate: values.StartDate,
            endDate: values.EndDate,
            campaignIds: campaignIds,
            isExport: true,
            pageIndex: 0,
            pageRecord:200
        };


        try {
            const response : any = await SearchFilter(payload);
            const status = response?.status;
            const message = response?.message
            
            if (status === '1004') {
                localStorage.clear();
                message.warning(message);
                setTimeout(() => {
                    navigate('/');
                }, 1000);
                return;
            } else if (status === '1005') {
                message.warning(message);
                setTableData([]);
                return;
            }

            if (response?.data) {
                setTableData(response.data); 
                setTotalRecords(response.total);
            } else {
                setTableData([]);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            message.error('Failed to fetch data');
        } finally {
            setSpinning(false);
        }
    };

    useEffect(() => {
        searchFilter();
    }, [currentPage, pageSize]);

    const onSubmit = () => {
        setCurrentPage(1); // Reset to first page on new search
    };

    const FilterClear = async () => {
        setValue('StartDate', '');
        setValue('EndDate', '');
        setValue('CampaignId', '');
        // fetch with empty filters
        setSpinning(true);
        try {
            const response: any = await SearchFilter({
                startDate: '',
                endDate: '',
                campaignIds: [],
                isExport: true,
                pageIndex: 0,
                pageRecord: 200,
            });
            if (response?.data) {
                setTableData(response.data);
                setTotalRecords(response.total);
                setCurrentPage(1);
            } else {
                setTableData([]);
            }
        } catch (error) {
            console.error('Error clearing filter:', error);
        } finally {
            setSpinning(false);
        }
    }

    return (
        <>
            <Header/>
            <div className={style.Route}>
                <h5>Reporting</h5>
            </div>
            <form className={style.form} onSubmit={handleSubmit(searchFilter)}>
                <div className={style.SearchTable}>
                    <div className={style.FormSetting}>
                        <Spin spinning={spinning} size='small' fullscreen />

                        <div className={style.field}>
                            <FormInput
                                Label='Start Date'
                                placeholder='Start Date'
                                classInput={style.Input}
                                className={style.inputContainer}
                                labelClass={style.Label}
                                classError={style.Error}
                                name='StartDate'
                                type='date'
                                errors={errors}
                                control={control}
                            />
                        </div>
                        <div className={style.field}>
                            <FormInput
                                Label='End Date'
                                placeholder='End Date'
                                classInput={style.Input}
                                className={style.inputContainer}
                                labelClass={style.Label}
                                classError={style.Error}
                                name='EndDate'
                                type='date'
                                errors={errors}
                                control={control}
                            />
                        </div>
                        <div className={style.field}>
                            <FormInput
                                Label='Campaign ID(s)'
                                placeholder='Comma-separated IDs (e.g., 1,2,3)'
                                classInput={style.Input}
                                className={style.inputContainer}
                                labelClass={style.Label}
                                classError={style.Error}
                                name='CampaignId'
                                errors={errors}
                                control={control}
                            />
                        </div>
                    </div>
                    <div className={style.btnSetting}>
                        <Button type='primary' htmlType='submit' className={style.buttonSignIn} >Search</Button>
                        <Button type='primary' className={style.buttonSignIn} onClick={FilterClear}>Clear</Button>
                    </div>
                </div>
            </form>
            <div className={style.btnSetting}>
                {hasPermission(PERMISSIONS.AUDIT_REPORT_DOWNLOAD)&&(
                <Button onClick={handleExport} className={style.buttonSignIn}>Export</Button>
                )}
            </div>
            <div className={style.container}>
                <Table
                    loading={loadingText}
                    columns={allColumns}
                    dataSource={tableData.slice((currentPage - 1) * pageSize, currentPage * pageSize)}
                    pagination={false}
                    size="small"
                />
                <Pagination
                    align="end"
                    showTotal={(total) => `Total ${total} items`}
                    current={currentPage}
                    total={tableData.length}
                    pageSize={pageSize}
                    onChange={(page, newSize) => {
                        setCurrentPage(page);
                        setPageSize(newSize);
                    }}
                    style={{ marginTop: 16 }}
                />
            </div>
        </>
    );
};

function mapStateToProps(state: any) {
    return {
        Reporting_Red: state.Reporting_Red,
    };
}



export default connect(mapStateToProps, Action)(MultiViewTable);